/* eslint-disable */
export default {
  TOTAL_DNI: {
    TITLE_TEXT: 'TOTAL INCIDENT ENERGY',
    BODY_TEXT: (<p>The sum of today&apos;s DNI per sqr meter * the reflective area of the installation&apos;s dishes.</p>),
    URL: '',
    IMG: ''
  },
  TOTAL_COLLECTED: {
    TITLE_TEXT: 'TOTAL ENERGY COLLECTED',
    BODY_TEXT: (<>
                 <p>The sum of today&apos;s fluid enthalpy change. Essentially the increase in energy contained in the system.</p>
                 <p> Calculated as:</p>
                 <p><b>Temp Increase * Flow Rate * Specific Heat of Fluid</b></p>
               </>),
    URL: '',
    IMG: ''
  },
  CONVERSION: {
    TITLE_TEXT: 'CONVERSION EFFICIENCY',
    BODY_TEXT: (<p>The percentage of the incident energy that is collected at the receiver.</p>),
    URL: '',
    IMG: ''
  },
  LAST_UPDATED: {
    TITLE_TEXT: 'LAST UPDATED',
    BODY_TEXT: (<p>The time of the most recent upload from the Supervisor computer.</p>),
    URL: '',
    IMG: ''
  },
  PERFORMANCE: {
    TITLE_TEXT: 'Day\'s Performance (Watts)',
    BODY_TEXT: (<p>Incident and Collected energy sampled every 15 seconds for the selected concentrator and date.</p>),
    URL: '',
    IMG: ''
  },
  PERFORMANCE_CUMULATIVE: {
    TITLE_TEXT: 'Day\'s Performance Cumulative (Kilowatts)',
    BODY_TEXT: (<>
                  <p>Incident and Collected energy sampled every 15 seconds for the selected concentrator and date.</p>
                  <p> Displayed cumulatively and scaled to kilowatts for readability.</p>
                </>),
    URL: '',
    IMG: ''
  },
  CURRENT_CONDITIONS: {
    TITLE_TEXT: 'Current Conditions',
    BODY_TEXT: (<>
                  <p>The latest weather readings from the site.</p>
                  <p>Most values come for a Davis Instruments Vantage Pro2 except Azimuth and Zenith which are calculated using PVLib.</p>
                </>),
    URL: '',
    IMG: ''
  },
   WEEKS_AVERAGE: {
    TITLE_TEXT: 'Week\'s Average',
    BODY_TEXT: (<p>Coming soon. </p>),
    URL: '',
    IMG: ''
  },
};
